// extracted by mini-css-extract-plugin
module.exports = {"main":"TeamsTitle_main__y_RRa"};